import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/product-6.jpg'


const _hoisted_1 = { class: "row justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "col-lg-12" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview-tab",
              tabindex: "0"
            }, [
              _createElementVNode("div", { class: "form-group mb-4" }, [
                _createElementVNode("label", { class: "label text-dark fs-18" }, "Project Preview Image"),
                _createElementVNode("div", { class: "form-control h-100 text-center position-relative p-4 p-lg-5" }, [
                  _createElementVNode("div", { class: "product-upload" }, [
                    _createElementVNode("label", {
                      for: "file-upload",
                      class: "file-upload mb-0"
                    }, [
                      _createElementVNode("i", { class: "ri-folder-image-line bg-primary bg-opacity-10 p-2 rounded-1 text-primary" }),
                      _createElementVNode("span", { class: "d-block text-body fs-14" }, [
                        _createTextVNode("Drag and drop an image or "),
                        _createElementVNode("span", { class: "text-primary text-decoration-underline" }, "Browse")
                      ])
                    ]),
                    _createElementVNode("input", {
                      id: "file-upload",
                      type: "file"
                    })
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode"
                }, [
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, [
                    _createTextVNode("\n"),
                    _createElementVNode("div", null, "<div class=\"form-group mb-4\">"),
                    _createTextVNode("\n"),
                    _createElementVNode("div", null, "    <label class=\"label text-dark fs-18\">Project Preview Image</label>"),
                    _createTextVNode("\n"),
                    _createElementVNode("div", null, "    <div class=\"form-control h-100 text-center position-relative p-4 p-lg-5\">"),
                    _createTextVNode("\n"),
                    _createElementVNode("div", null, "        <div class=\"product-upload\">"),
                    _createTextVNode("\n"),
                    _createElementVNode("div", null, "            <label for=\"file-upload\" class=\"file-upload mb-0\">"),
                    _createTextVNode("\n"),
                    _createElementVNode("div", null, "                <i class=\"ri-folder-image-line bg-primary bg-opacity-10 p-2 rounded-1 text-primary\"></i>"),
                    _createTextVNode("\n"),
                    _createElementVNode("div", null, "                <span class=\"d-block text-body fs-14\">Drag and drop an image or <span class=\"text-primary text-decoration-underline\">Browse</span></span>"),
                    _createTextVNode("\n"),
                    _createElementVNode("div", null, "            </label>"),
                    _createTextVNode("\n"),
                    _createElementVNode("div", null, "            <input id=\"file-upload\" type=\"file\">"),
                    _createTextVNode("\n"),
                    _createElementVNode("div", null, "        </div>"),
                    _createTextVNode("\n"),
                    _createElementVNode("div", null, "    </div>"),
                    _createTextVNode("\n"),
                    _createElementVNode("div", null, "</div>"),
                    _createTextVNode("\n")
                  ]),
                  _createTextVNode("\n")
                ]),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "col-lg-12" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab2",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview2-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview2-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview2-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code2-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code2-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTab2Content"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview2-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview2-tab",
              tabindex: "0"
            }, [
              _createElementVNode("div", { class: "form-group" }, [
                _createElementVNode("label", { class: "label text-dark fs-18" }, "File Upload - Product Gallery"),
                _createElementVNode("div", { class: "form-control h-100 text-center position-relative p-4 p-lg-5" }, [
                  _createElementVNode("div", { class: "product-upload" }, [
                    _createElementVNode("label", {
                      for: "file-upload",
                      class: "file-upload mb-0"
                    }, [
                      _createElementVNode("i", { class: "ri-upload-cloud-2-line fs-2 text-gray-light" }),
                      _createElementVNode("span", { class: "d-block fw-semibold text-body" }, "Drop files here or click to upload.")
                    ]),
                    _createElementVNode("input", {
                      id: "file-upload",
                      type: "file"
                    })
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code2-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code2-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode2"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode2"
                }, [
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "<div class=\"form-group\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <label class=\"label\">File Upload - Product Gallery</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <div class=\"form-control h-100 text-center position-relative p-4 p-lg-5\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <div class=\"product-upload\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <label for=\"file-upload\" class=\"file-upload mb-0\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <i class=\"ri-upload-cloud-2-line fs-2 text-gray-light\"></i>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <span class=\"d-block fw-semibold text-body\">Drop files here or click to upload.</span>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            </label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <input id=\"file-upload\" type=\"file\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "</div>"),
                  _createTextVNode("\n")
                ]),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "col-lg-12" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab3",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview3-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview3-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview3-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code3-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code3-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTab3Content"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview3-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview3-tab",
              tabindex: "0"
            }, [
              _createElementVNode("label", { class: "label text-dark fs-18" }, "File Upload - Product Image2"),
              _createElementVNode("div", { class: "form-group p-4 d-sm-flex justify-content-between align-items-center rounded-3" }, [
                _createElementVNode("div", { class: "d-sm-flex align-items-center mb-3 mb-sm-0 me-lg-3" }, [
                  _createElementVNode("div", { class: "me-md-5 pe-xxl-5 mb-3 mb-sm-0" }, [
                    _createElementVNode("h4", { class: "body-font fs-15 fw-semibold text-body" }, " Project Avatar "),
                    _createElementVNode("p", null, "This will displayed on your project avatar.")
                  ]),
                  _createElementVNode("img", {
                    src: _imports_0,
                    class: "rounded-4 wh-160 ms-3 ms-lg-0",
                    alt: "product"
                  })
                ]),
                _createElementVNode("div", { class: "d-flex ms-sm-3 ms-md-0" }, [
                  _createElementVNode("button", { class: "btn bg-danger bg-opacity-10 text-danger fw-semibold" }, " Delete "),
                  _createElementVNode("button", { class: "btn bg-primary bg-opacity-10 text-primary fw-semibold ms-3" }, " Update ")
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code3-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code3-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode3"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode3"
                }, [
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "<div class=\"form-group p-4 d-sm-flex justify-content-between align-items-center rounded-3\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <div class=\"d-sm-flex align-items-center mb-3 mb-sm-0 me-lg-3\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <div class=\"me-md-5 pe-xxl-5 mb-3 mb-sm-0\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <h4 class=\"body-font fs-15 fw-semibold text-body\">Project Avatar</h4>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <p>This will displayed on your project avatar.</p>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <img src=\"@/assets/images/product-11.jpg\" class=\"rounded-4 wh-78 ms-3 ms-lg-0\" alt=\"product\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <div class=\"d-flex ms-sm-3 ms-md-0\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <button class=\"btn bg-danger bg-opacity-10 text-danger fw-semibold\">Delete</button>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <button class=\"btn bg-primary bg-opacity-10 text-primary fw-semibold ms-3\">Update</button>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "</div>"),
                  _createTextVNode("\n")
                ]),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1)
  ]))]))
}